const ONBOARDING_ENABLED = true;
const SHOW_ENGAGED_SURVEY = false;
const EXTENSION_INSTALL_URL = 'https://chrome.google.com/webstore/detail/filedriver-for-chrome/hiiahgelfnfpdcbfbihjdmpjcmglbbgc';
const NETWORK_REQUEST_TIME_OUT = 10000;
const DEFAULT_PACKAGE_ID = 1;
export default { ONBOARDING_ENABLED, SHOW_ENGAGED_SURVEY, EXTENSION_INSTALL_URL, NETWORK_REQUEST_TIME_OUT, DEFAULT_PACKAGE_ID}